<template>
  <div class="modal-window">
    <button type="button" @click="$emit('close')" class="button button--close">
      <IconClose class="icon icon--medium-large" />
    </button>
    <form>
      <div class="layout--text-left modal-window__wrap">
        <Legend class="modal-window__title">Session Expiring</Legend>
        <p class="layout--margin-bottom-lg">
          You have been logged out for being idle for over 15 minutes.
        </p>
        <div class="layout--flex-space-between layout--margin-top-sm">
          <button type="button" class="button" @click="$emit('close')">
            Close
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconClose from "../assets/icons/iconCloseX.svg";

export default {
  name: "timeoutModal",
  props: {
    timeToExpire: Number,
  },
  components: {
    IconClose,
  },
};
</script>

<style lang="scss">
@import "../styles/components/_modal.scss";
</style>
